'use strict';

goog.provide("Ntry.JrItemSystem");

goog.require("Ntry.STATIC");

Ntry.JrItemSystem = function() {
    Ntry.addEventListener("run", this, this.raiseItem);
    Ntry.addEventListener("stop", this, this.resetItem);
    Ntry.addEventListener("getItem", this, this.getItem);
};

(function(p){
    p.update = function(frameCount) {
        if (!this._unit)
            this.findUnit();
        else if (!Ntry.entityManager.hasComponent(this._unit.id, Ntry.STATIC.UNIT))
            this.findUnit();
        if (!this._unit)
            return;

        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.ITEM);

        var unitPosition = Ntry.entityManager.getComponent(
            this._unit.id, Ntry.STATIC.POSITION);

        var unitGrid = Ntry.entityManager.getComponent(
            this._unit.id, Ntry.STATIC.GRID);

        for (var id in entities) {

            var itemComp = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.ITEM);

            if (itemComp.isEaten) {
                continue;
            }

            var itemPosition = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.POSITION);

            var itemGrid = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.GRID);
            if (itemComp.itemType == Ntry.STATIC.GOAL_ITEM)  { //0
                if (itemPosition.y - itemComp.tolerance < unitPosition.y &&
                    itemPosition.y + itemComp.tolerance > unitPosition.y &&
                    itemPosition.x - itemComp.tolerance < unitPosition.x &&
                    itemPosition.x + itemComp.tolerance > unitPosition.x &&
                    itemGrid.x == unitGrid.x && itemGrid.y == unitGrid.y) {

                    Ntry.dispatchEvent("itemFire", itemComp.itemType);

                    var stageId = Ntry.configManager.getConfig("stageId");
                    Ntry.dispatchEvent("jrActivityStageFinish", stageId);
                    itemComp.isEaten = true;
                }
            }

            var spriteComp = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.SPRITE);

            if (spriteComp)
                if (frameCount % 8 == 0)
                    spriteComp.currentFrame = 0;
                else if (frameCount % 8 == 4)
                    spriteComp.currentFrame = 1;
        };

    };
    p.getItem = function(frameCount) {
        // 아이템 체크.
        if (!this._unit) this.findUnit();
        else if (!Ntry.entityManager.hasComponent(this._unit.id, Ntry.STATIC.UNIT))
            this.findUnit();
        if (!this._unit) return;

        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.ITEM);

        // juni's position(x,y)
        var unitPosition = Ntry.entityManager.getComponent(
            this._unit.id, Ntry.STATIC.POSITION);

        // juni's grid
        var unitGrid = Ntry.entityManager.getComponent(
            this._unit.id, Ntry.STATIC.GRID);

        var eatAny = false;
        for (var id in entities) {
            var itemComp = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.ITEM);

            if (itemComp.isEaten) continue;

            var itemPosition = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.POSITION);

            var itemGrid = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.GRID);

            if (this.checkItemPos(itemGrid , unitGrid)) {
                if (!itemComp.isEaten) {
                    itemComp.isEaten = true;
                    Ntry.dispatchEvent("itemFire", itemComp.itemType);
                    eatAny = true;
                }

                if (Ntry.STATIC.CONSUMABLE_ITEMS.indexOf(itemComp.itemType) > -1) {
                    Ntry.entityManager.addComponent(
                        id, {
                            type: Ntry.STATIC.ANIMATE,
                            animateType: Ntry.STATIC.FADE_OUT,
                            duration: 0.5
                        }
                    );
                }
            }
            var spriteComp = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.SPRITE);

            if (spriteComp)
                if (frameCount % 8 == 0)
                    spriteComp.currentFrame = 0;
                else if (frameCount % 8 == 4)
                    spriteComp.currentFrame = 1;
        };
        if (!eatAny)
            Ntry.dispatchEvent("complete",false, Ntry.STATIC.GET_ITEM);
    };

    p.checkItemPos = function(Grid, Unit) {
        if(Grid.x == Unit.x && Grid.y == Unit.y)
            return true;

        return false;
    };

    p.raiseItem = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.ITEM);
        for (var id in entities) {
            var itemComp = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.ITEM
            );

            Ntry.dispatchEvent("raiseItem", itemComp.itemType);
        }
    };

    p.resetItem = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.ITEM);
        for (var id in entities) {
            var itemComp = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.ITEM
            );
            itemComp.isEaten = false;
        }
    };

    p.findUnit = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.UNIT);

        for (var key in entities) {
            this._unit = entities[key];
        }
    };
})(Ntry.JrItemSystem.prototype);
